import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import antd, { Icon } from "ant-design-vue";
import "@/styles/index.scss";
import "ant-design-vue/dist/antd.css";
import start from "@/qiankun/micro";
import GlobalLogin from "@/plugins/global-login";
import axios from "axios";
// 创建全局图标组件
const globalIcon = Icon.createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/c/font_4423319_l558020jcn8.js", // 替换为你的图标链接
});
// 注册全局组件
// eslint-disable-next-line vue/multi-word-component-names
Vue.component("Icon", globalIcon);
// Vue.prototype.$icon = globalIcon
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.use(antd);
// 注册全局登录插件
Vue.use(GlobalLogin);
start({
  sandbox: {
    experimentalStyleIsolation: true, // 样式隔离
  },
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
